import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M18.875 5.125H19.5V4.5H18.875V5.125ZM18.875 18.875V19.5H19.5V18.875H18.875ZM5.125 18.875H4.5V19.5H5.125V18.875ZM5.125 5.125V4.5H4.5V5.125H5.125ZM10.75 5.125V4.5H9.5V5.125H10.75ZM9.5 18.875V19.5H10.75V18.875H9.5ZM5.125 9.5H4.5V10.75H5.125V9.5ZM18.875 10.75H19.5V9.5H18.875V10.75ZM18.25 5.125V18.875H19.5V5.125H18.25ZM18.875 18.25H5.125V19.5H18.875V18.25ZM5.75 18.875V5.125H4.5V18.875H5.75ZM5.125 5.75H18.875V4.5H5.125V5.75ZM9.5 5.125V10.125H10.75V5.125H9.5ZM9.5 10.125V18.875H10.75V10.125H9.5ZM5.125 10.75H10.125V9.5H5.125V10.75ZM10.125 10.75H18.875V9.5H10.125V10.75Z",
		fill: "currentColor"
	})]
});
export default SvgTable;
